import { SET_ROOM } from '../../../../react/features/base/conference/actionTypes';
import { updateConfig } from '../../../../react/features/base/config/actions';
import MiddlewareRegistry from '../../../../react/features/base/redux/MiddlewareRegistry';
/**
 * Middleware that catches actions related to participants and tracks and
 * dispatches an action to select a participant depicted by LargeVideo.
 *
 * @param {Store} store - Redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    const result = next(action);
    // @ts-ignore
    if (!APP.wildix.wizy) {
        return result;
    }
    switch (action.type) {
        case SET_ROOM: {
            // @ts-ignore
            store.dispatch(updateConfig({ videoQuality: { enableAdaptiveMode: false } }));
            break;
        }
    }
    return result;
});
